<template>
    <div class="input-group flex">
        <input v-if="is_mobile"
               :name="name"
               type="time"
               :value="time"
               @input="onChange"
               autocomplete="off"
               ref="timeField"
               class="input">
        <flat-pickr v-else
                    :value="time"
                    :config="config"
                    class="input"
                    :class="classes"
                    @on-change="onChange"
                    ref="flatpickr"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    :name="name"
        ></flat-pickr>

        <button v-if="hasResetButton" class="input-group-addon timepicker-icon" @click="reset">
            <i class="fal fa-times"></i>
        </button>

        <span v-if="hasIcon" class="input-group-addon timepicker-icon cursor-pointer" @click="openFlatPickr">
            <i class="fal fa-clock"></i>
        </span>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {flatPickr},

        props: {
            value: {},
            classes: {
                default: null
            },
            hasIcon: {
                default: true
            },
            mode: {
                default: 'single'
            },
            disabled: {
                default: false
            },
            placeholder: {
                default: ''
            },
            hasResetButton: {
                type: Boolean,
                default: false
            },
            enableSeconds: {
                type: Boolean,
                default: false
            },
            time_24hr: {
                type: Boolean,
                default: false
            },
            name: {
                type: String,
                default: null,

            }
        },

        data() {
            return {
                time: this.value,
                config: {
                    mode: this.mode,
                    enableTime: true,
                    time_24hr: this.time_24hr,
                    enableSeconds: this.enableSeconds,
                    noCalendar: true
                },
            }
        },

        computed: {
            is_mobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            }
        },

        methods: {
            onChange(selectedTimes, timeStr, instance) {
                if (this.is_mobile) {
                    this.$emit('input', selectedTimes.target.value);
                    return;
                }
                this.$emit('input', timeStr);
            },

            openFlatPickr() {
                if (this.is_mobile) {
                    this.$refs.timeField.focus();
                    this.$refs.timeField.click();
                    return;
                }
                this.$refs.flatpickr.fp.open()
            },
            reset() {
                this.$emit('input', null);
            },
        },

        watch: {
            value(value) {
                this.time = value
            },
        },
    }
</script>

<style scoped>
    .timepicker-icon {
        font-size: 1rem;
        padding: 0 0.75rem;
    }
</style>
